import api from "./api.js";

export default class FaqApi {
  static async createFaq(data) {
    return await api.post(`api/faq`, data);
  }

  static async getFaqList(data) {
    return await api.get(`api/faq`, data);
  }

  static async getFaqDetail(id) {
    return await api.get(`api/faq/${id}`);
  }

  static async editFaq(id, data) {
    return await api.patch(`api/faq/${id}`, data);
  }

  static async delFaq(data) {
    return await api.del(`api/faq`, data);
  }
}
